import { Container, CircularProgress, Stack, Button, Tabs, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { useParams, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { capturePHEvents } from '../../../analytics/posthog.analytics';
import {
  PH_ADD_STUDENT_CLICK,
  PH_TEACHER_CLASS_DETAILS_TAB_CHANGE
} from '../../../utils/posthog.eventNames';
import AddPopup from '../../../components/AddPopup';
// import { fetchClassById } from '../../../service/class.service';
import Page from '../../../components/Page';
import Header from '../../../components/Header';
import { getChatMessage } from '../../../firebase/actions/firebaseGet';
import { teacherClassTopBarOptions } from '../../../utils/constants';
import TeacherOverview from './ClassDetails/Teacher.Overview';
import TeacherResources from './ClassDetails/Teacher.Resources';
import TeacherTest from './ClassDetails/Teacher.Test';
import TeacherStudents from './ClassDetails/Teacher.Student';
import TeacherAssignments from './ClassDetails/Teacher.Assignment';
import { sortArrayInAscending } from '../../../helper/commonHelper';
import NewChat from '../../Chat/NewChat';
import TeacherAttendance from './ClassDetails/Teacher.Attendance';
import { CLASS_OPERATIONS } from '../../../redux/constants';
import { captureGAEvents } from '../../../analytics/google.analytics';
import { GAEvents } from '../../../analytics/events.constants';

const useStyles = makeStyles({
  headerAndButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  contentContainer: {
    marginTop: 20
  }
});

export default function TeacherClassDetails() {
  const classes = useStyles();
  const location = useParams();
  const navigate = useNavigate();
  const selectedClass = useSelector((state) => state.classes.selectedClass);
  const [isClassLoading, setIsClassLoading] = useState(false);
  const dispatch = useDispatch();
  // const [studentList, setStudentList] = useState([]);
  const [classData, setClassData] = useState(selectedClass);
  const [currentTab, setCurrentTab] = useState(0);
  const [chatMessages, setMessages] = useState([]);
  const [isChatLoading, setIsChatLoading] = useState(true);
  const classId = location.id;
  // == Track Popup State ==
  const [isAddStudentPopupOpen, setIsAddStudentPopupOpen] = useState(false);
  const classList = useSelector((state) => state.classes.classData);

  const fetchClassWhenUpdate = (data) => {
    setIsClassLoading(true);
    // const classRes = await fetchClassById(classData.id);
    // if (classRes) {
    dispatch({
      type: CLASS_OPERATIONS,
      payload: {
        action: 'update',
        classObj: { id: data._id, ...data }
      }
    });
    setClassData({ id: data._id, ...data });
    setIsClassLoading(false);
    // } else {
    //   setIsClassLoading(false);
    // }
  };

  const getMessages = () => {
    getChatMessage(classId)
      .then((r) => {
        const message = [];
        r.forEach((d) => {
          message.push({ ...d.data(), firebaseId: d.id });
        });
        setMessages(sortArrayInAscending(message, 'createdAt'));
        // setMessages(message);
        setIsChatLoading(false);
      })
      .catch(() => {
        setMessages({
          error: true
        });
        setIsChatLoading(false);
      });
  };

  useEffect(() => {
    getMessages();
    captureGAEvents(GAEvents.classesScreen, {
      screen: 'teacher_class_detail'
    });
  }, []);

  return (
    <>
      <Page
        title={`Class Details - ${classData?.name}`}
        style={{
          display: `${isClassLoading ? 'flex' : ''}`,
          width: `${isClassLoading ? '100%' : ''}`,
          height: `${isClassLoading ? '100%' : ''}`,
          justifyContent: `${isClassLoading ? 'center' : ''}`,
          alignItems: `${isClassLoading ? 'center' : ''}`
        }}
      >
        <Container>
          {isClassLoading ? (
            <CircularProgress />
          ) : (
            <>
              <div className={classes.headerAndButtonContainer}>
                <Header title={classData.name} onBack={() => navigate('/dashboard/classes')} />
              </div>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1, sm: 2, md: 4 }}
                alignItems={{ sm: 'center' }}
                justifyContent={{ sm: 'space-between' }}
                mb={2}
              >
                <Tabs
                  value={currentTab}
                  onChange={(event, newValue) => {
                    capturePHEvents(PH_TEACHER_CLASS_DETAILS_TAB_CHANGE, {
                      classId: classData.id,
                      className: classData.name,
                      selectedTab: event.target.innerText
                    });
                    setCurrentTab(newValue);
                  }}
                  variant="scrollable"
                  scrollButtons={false}
                  aria-label="scrollable prevent tabs example"
                >
                  {teacherClassTopBarOptions.map((t, i) => (
                    <Tab label={t.title} key={i} />
                  ))}
                </Tabs>
                {currentTab === 3 && (
                  <Button
                    variant="contained"
                    onClick={() => {
                      capturePHEvents(PH_ADD_STUDENT_CLICK, { classId: classData.id });
                      setIsAddStudentPopupOpen(true);
                    }}
                    startIcon={<Icon icon={plusFill} />}
                  >
                    Add Student
                  </Button>
                )}
              </Stack>
              {currentTab === 0 && (
                <TeacherOverview
                  classDetails={classData}
                  handleClassUpdate={(data) => fetchClassWhenUpdate(data)}
                />
              )}
              {currentTab === 1 && <TeacherResources classId={classData.id} />}
              {currentTab === 2 && <TeacherTest classId={classData.id} />}
              {currentTab === 3 && <TeacherStudents classDetails={classData} />}
              {currentTab === 4 && (
                <NewChat
                  chatMessage={chatMessages}
                  isChatLoading={isChatLoading}
                  classId={classId}
                  classDetails={classData}
                />
              )}
              {currentTab === 5 && <TeacherAssignments classId={classData.id} />}
              {currentTab === 6 && <TeacherAttendance classDetails={classData} />}
            </>
          )}
        </Container>
      </Page>
      <AddPopup
        isOpen={isAddStudentPopupOpen}
        title="Add Student"
        handleClosePopup={() => setIsAddStudentPopupOpen(!isAddStudentPopupOpen)}
        popUpType="student"
        studentClassList={classList || []}
        selectedClassId={classData.id}
      />
    </>
  );
}
